<div class="px-8 py-4 bg-slate-50/50 border-t border-slate-300 flex flex-col sm:flex-row items-center justify-between gap-4">
  <div class="text-[12px] font-medium text-slate-600">
    Showing
    <span class="font-bold text-slate-700">{{ startItem() }}</span>
    to
    <span class="font-bold text-slate-700">{{ endItem() }}</span>
    of
    <span class="font-bold text-slate-700">{{ totalItems() }}</span>
    {{ itemLabel() }}
  </div>

  <div class="flex items-center gap-1">
    <button (click)="firstPage()" [disabled]="currentPage() === 1"
      class="p-2 text-slate-600 hover:text-slate-900 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
      aria-label="First Page">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M11 19l-7-7 7-7M18 19l-7-7 7-7" />
      </svg>
    </button>

    <button (click)="prevPage()" [disabled]="currentPage() === 1"
      class="p-2 text-slate-600 hover:text-slate-900 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
      aria-label="Previous Page">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
      </svg>
    </button>

    <div class="flex items-center gap-1 px-1">
      <span class="text-[12px] font-medium text-slate-600">Page</span>
      <span class="text-[12px] font-bold text-slate-700">{{ currentPage() }}</span>
      <span class="text-[12px] font-medium text-slate-600">of {{ totalPages() }}</span>
    </div>

    <button (click)="nextPage()" [disabled]="currentPage() === totalPages()"
      class="p-2 text-slate-600 hover:text-slate-900 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
      aria-label="Next Page">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
      </svg>
    </button>

    <button (click)="lastPage()" [disabled]="currentPage() === totalPages()"
      class="p-2 text-slate-600 hover:text-slate-900 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
      aria-label="Last Page">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M13 5l7 7-7 7M6 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>
